<template>
	<!---kropp-med-mindre-pad-right-left-bottom -->
	<!--	@click="onClick"-->
	<eui-panel
		:vp-huvud-text="chartTitle"

		:vp-inaktiverad="skaVaraInaktiverad"
		:disabled="skaVaraInaktiverad"
		:vp-osynlig="skaVaraOsynlig"
		:class="{
			'-osynlig':skaVaraOsynlig
		}"
		:vp-visa-menyfaltet="vpArIRedigeralage"
		:vp-meny-config.sync="menyConfig"

		class="-kropp-med-overflow-visible"
		style="width: 100%; height: 100%;"

		@menyalternativ-valt-i-panel="onMenyalternativValtIPanel"
	>
		<!-- Kroppen (default slot): -->
		<!--	:class="{ '-inaktiverad':this.vpArIRedigeralage || this.$parent.isDragging || this.$parent.isResizing }"-->
		<!--	:class="{ '-inaktiverad': endastKroppenSkaVaraInaktiverad}"
			:disabled="endastKroppenSkaVaraInaktiverad"-->

<!-- use capture mode when adding the event listener:
i.e. an event targeting an inner element is handled here before being handled by that element
<div v-on:click.capture="doThis">...</div>
-->
		<!--<a class="bildlank" tabindex="-1" :href="'/diagramsida?widgetId=' + this.vpWidgetId + '&month=' + this.vpWidgetMonth" style="width:100%; height:100%; cursor: zoom-in;">-->

			<!--	:vp-force-no-legend="true"-->
			<!--	style="cursor: zoom-in;"-->
			<eui-multichart
				:vp-widget-settings.sync="widgetSettings"
				:vp-ar-i-andralage.sync="arIAndralage"
				:vp-widget-data="vpWidgetData"
				:vp-force-no-title="true"
				@title-set="onTitleSet"
				@widget-settings-andrade="onWidgetSettingsAndrade"
				@klickat-pa-multichart="onKlickatPaMultichart"
			></eui-multichart>

		<!--</a>-->

	</eui-panel>

</template>


<script>
	// ################################################################################################################

	import euiPanel from 'v-components/euiPanel';
	import { ssoGeneriskWidgetMixin } from 'v-mixins/ssoGeneriskWidgetMixin';

	import euiMultichart from 'v-components/euiMultichart.vue';

	import objectToFormData from 'object-to-formdata';


	export default {
		name: 'chartwidget',

		// All generisk widgetfunktionalitet, se 'ssoGeneriskWidgetMixin.js'.
		mixins: [ssoGeneriskWidgetMixin],

		// Lokalt registrarade komponenter
		components: {
			euiMultichart,
			euiPanel,	//[euiPanel.name]: euiPanel,
		},

		// Utöver de från mixin ovan:
		//props: {
		//},

		// Utöver de från mixin ovan:
		data() {
			return {
				chartTitle: ' ',	// Sätts om då event säger att det är färdigt. Mellanslag, för höjden på huvudet blir annorlunda för '' vs. ' '!

				widgetSettings: this.vpWidgetSettings,
			}
		},

		// Utöver de från mixin ovan:
		watch: {
			widgetSettings: {
				// Obs! Denna watch är "deep"!
				handler(nyttVarde, tidigareVarde)
				{
					// Propen används med .sync i parent component:
					this.$emit('update:vpWidgetSettings', nyttVarde);
				},
				deep: true,
			},
		},

		// Utöver de från mixin ovan:
		methods: {
			onTitleSet(titel)
			{
				this.chartTitle = titel;
			},

			onKlickatPaMultichart()
			{
				// Navigera till ny sida:
				window.location.href = '/diagramsida?widgetId=' + this.vpWidgetId + '&month=' + this.vpWidgetMonth;

				// Skicka event att det klickats på diagrammet:
				this.$emit('klickat-pa-multichart');
			},

			onWidgetSettingsAndrade(nyaWidgetSettings)
			{
				// Användaren har ändrat inställningar för diagrammet:

				// När man kommer hit: Allt validerar *client-side* (*standard-valideringar*).

				// UI och dess underliggande data är redan "live" uppdaterade med rätt nya värden (via reaktivitet).
				// Obs! DENNA "LIVE" METOD FÖRUTSÄTTER antagligen att värdena i dialogen *aldrig* kan bli invalid!
				// I detta läge är alltså, om *allt* reaktivt hunnit bli klart (!), nyaWidgetSettings (deep) === this.widgetSettings (deep) === this.vpWidgetSettings (deep) === parents vpWidgetSettings (deep).
				// Vi arbetar dock med nyaWidgetSettings här så slipper vi bekymra oss om reaktivitetens status.

				// Dialogrutan är än så länge *inte* stängd och eui-multichart-komponenten håller fortfarande undansparade gamla värdet för den eventualitet att sparningen fallerar om vi låter användaren stanna kvar i dialogen (och där kan välja Avbryt)!

				this.$root.AjaxpostaOchHanteraResultat('/widget/update-widget-settings', {
					formData: objectToFormData({
							widgetId: this.vpWidgetId,
							widgetElementName: this.vpWidgetElementName,
							widgetSettings: JSON.stringify(nyaWidgetSettings),
						}),
					//withoutSpinner: false,
					doljSpinnerOnSuccess: true,
					//onFailureFunction: undefined,
					//onCatchedErrorFunction: undefined,
					onSuccessFunction: (resultat) => {

						// Först nu ska dialogen stängas!
						// Ta widgeten ur ändraläge:
						this.arIAndralage = false;
					},
				});
			}
		},


		//== Lifecycle hooks  ================================================================================================================

	}
</script>

